import { LepcInput } from "generated-graphql/graphql";

export function transform(input: LepcInput): LepcInput {
  return {
    ...input,
    latitude: input.latitude ? Number(input.latitude) : null,
    longitude: input.longitude ? Number(input.longitude) : null,
    dueDate: input.dueDateIsAnniversary ? null : input.dueDate,
    dueDateIsAnniversary: input.dueDateIsAnniversary ?? false,
  };
}
